import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

/**
 * Fetches the account's customer custom-property keys, used to generate one
 * CUSTOMER switch operator per key. Shares the query cache with the
 * `/workflows` router preloader (same query key), so it resolves immediately in
 * the editor and adds no latency at publish time.
 *
 * Custom-property keys are non-critical: if the fetch fails — or there's no API
 * available, e.g. in unit tests — it falls back to no per-key operators, and
 * the identity Includes/Excludes operators still work. `retry: false` keeps
 * that fallback fast.
 */
export const fetchCustomerCustomPropertyKeys = async (): Promise<string[]> => {
  try {
    const data = await apiQueryClient.fetchQuery({
      queryKey: dashboard20240730Client.getCustomerCustomPropertyKeys.queryKey,
      queryFn: async () =>
        (await dashboard20240730Client.getCustomerCustomPropertyKeys.request())
          ?.data,
      staleTime: 5 * MINUTES,
      retry: false
    })
    return data?.items ?? []
  } catch {
    return []
  }
}
